import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  constructor() { }

  // Validador personalizado para no permitir espacios en blanco
  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null; // No validar si está vacío (required lo manejará)
      }
      const hasWhitespace = /\s/.test(value);
      return hasWhitespace ? { whitespace: true } : null;
    };
  }

  // Verifica si el campo es inválido y ha sido tocado
  isValidField(control: AbstractControl): boolean | null {
    return control.errors && control.touched;
  }

  // Obtiene el mensaje de error para un campo específico
  getFieldError(control: AbstractControl): string | null {
    if (!control) return null;

    const errors: ValidationErrors = control.errors || {};

    for (const key of Object.keys(errors)) {
      switch (key) {
        case 'required':
          return 'El campo es requerido.';
        case 'minlength':
          return `Mínimo ${errors[key].requiredLength} caracteres.`;
        case 'maxlength':
          return `Máximo ${errors[key].requiredLength} caracteres.`;
        case 'invalidIp': 
          return 'Ingrese una dirección IP válida.';
        case 'pattern':
          return 'El valor no cumple con el patrón requerido.';
        case 'whitespace':
          return 'No se permiten espacios en blanco.';
        case 'extensionInvalid':
          return 'El archivo no tiene una extensión válida.';
          case 'extensionInvalidExcel':
          return 'El archivo debe ser de formato Excel (.xlsx o .xls).';
        case 'email':
          return 'Ingrese un correo electrónico válido.';
        // Añade más casos según las validaciones que requieras
        default:
          return 'Revisa la información ingresada.';
        }
    }

    return null;
  }

  fileExtensionValidator(allowedExtensions: string[], errorKey: string = 'extensionInvalid') {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) return null;

      // Manejar múltiples archivos o un solo archivo
      const files: File[] = Array.isArray(value) ? value : [value];

      // Verificar que todos los archivos tengan extensión permitida
      const hasInvalidFile = files.some(file => {
        const extension = file.name.split('.').pop()?.toLowerCase();
        return !allowedExtensions.includes(extension || '');
      });

      // Si hay algún archivo con extensión no permitida, retornar error
      return hasInvalidFile ? { [errorKey]: true } : null;
    };
  }

  ipValidator(): ValidatorFn {
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; // Regex para IPv4

    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const valid = ipRegex.test(control.value);
      return valid ? null : { invalidIp: true };
    };
  }
}
